import React from 'react';
import Seo from '../../components/Seo';
import PolicyHero from '../../components/PolicyHero';
import NewFooter from '../../components/NewFooter';
import './complaints.css';

const HERO_IMAGE = '/assets/images/banner-general.png';

function ComplaintsPage() {
  return (
    <div className="cp-page">
      <Seo
        title="My Private Chemist | Complaints"
        description="Not happy with our service? Read how to raise a complaint with My Private Chemist and learn how we handle and resolve customer concerns."
        canonical={`${process.env.REACT_APP_BASE_URL}/complaints`}
        url={`${process.env.REACT_APP_BASE_URL}/complaints`}
        image={`${process.env.REACT_APP_BASE_URL}${HERO_IMAGE}`}
      />
      <PolicyHero
        title="Complaints"
        pageName="Complaints"
        heroImage={HERO_IMAGE}
      />

      <main className="cp-main">
        <div className="cp-content">
          <p className="cp-text">
            At My Private Chemist, it is our utmost priority to offer world-class services reliably
            at a price our clients are happy with. We set the highest standard for ourselves but we
            are only human and even we make mistakes at times. The first step in solving a problem is
            realising there is one. So, get in touch with us. Your feedback matters and we take it
            very seriously to resolve it as soon as possible. In the unlikely event that the problem
            is not resolved, you can lodge a formal complaint. All you need to do is fill in our
            complaints form and send it us via email or post. We aim to respond within 48 hours.
          </p>
        </div>
      </main>

      <NewFooter />
    </div>
  );
}

export default ComplaintsPage;
